import { mdiTextAccount } from '@mdi/js'

export default {
  title: 'E-Voting',
  to: 'evoting-school-list',
  icon: mdiTextAccount,
  resource: 'EvotingSchool',
  action: 'read',
}
